import axios from 'axios'
import { useCallback } from 'react'
import {
  setSignatureCancelToken,
  failureSignatureUploadFile,
  successSignatureUploadFile,
} from 'Application/Account/store'
import { base64ToBlob, inferImageName } from 'Utils/files'
import { deleteAllBasicData } from 'DataBase/BasicDataDB'
import { useAppDispatch } from 'Store/selectors'
import { useUploadVisitFileMutation, useAssignSignatureMutation } from '../services/api'

export function useUploadSignatureFile() {
  const dispatch = useAppDispatch()

  const [uploadVisitFile, visitFile] = useUploadVisitFileMutation()
  const [assignSignature, signature] = useAssignSignatureMutation()

  const uploadSignatureFile = useCallback(
    async ({
      file,
      expertId,
      onComplete,
    }: {
      file: any
      expertId: number | null
      onComplete?: VoidFunction
    }) => {
      try {
        // Convert
        const base64 = file.image.replace(`data:${file.fileType};base64,`, '')
        const blobImage = base64ToBlob(base64, file.fileType)
        const imageName = inferImageName(file.fileType)

        // Cancel token
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setSignatureCancelToken(source))

        // Upload
        const res = await uploadVisitFile({ file: blobImage!, fileName: imageName }).unwrap()

        dispatch(successSignatureUploadFile(res))

        await assignSignature({
          id: expertId,
          signatureImageId: res,
        }).unwrap()

        await deleteAllBasicData()

        if (onComplete) onComplete()

        window.location.reload()
      } catch (err) {
        dispatch(failureSignatureUploadFile())
        throw err
      }
    },
    [dispatch, uploadVisitFile, assignSignature]
  )

  const isUploadLoading = visitFile.isLoading || signature.isLoading

  return { uploadSignatureFile, isUploadLoading }
}
